import {customElement} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import {ImmutableComponent} from '#lit/components/mixins/immutable_component/index.js';
import type {Constructor} from '#lit/types/classes.js';
import styles from './style.scss';
import type {Option} from '#lit/components/base/select_async/index.js';
import type {AudienceBuilderField} from '#lit/types/builders/audience_builder/index.js';
import {property} from 'lit-element';
import type {Model} from './architecture.js';
import {Msg, main} from './architecture.js';

export const AUDIENCE_BUILDER_FIELD_ELEMENT_TAG = 'audience-builder-field';

/**
 * FlyListItemAudienceBuilderFields
 *
 * higher order component around a fly-list-item for rendering audience field information
 *
 * @fires selected
 * @fires deselected
 */
@customElement(AUDIENCE_BUILDER_FIELD_ELEMENT_TAG)
export class FlyListItemAudienceBuilderFields extends ImmutableComponent<
  Constructor<FlywheelComponent>,
  Model,
  Msg
>({
  component: FlywheelComponent,
  main,
}) {
  @property({type: Object})
  get option(): Option<AudienceBuilderField> {
    return this.model.option;
  }
  set option(value: Option<AudienceBuilderField>) {
    this.handleUpdate(Msg.setOption(value));
  }

  @property({type: Number})
  maxDescriptionLength = 60;

  static get styles() {
    return [styles];
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [AUDIENCE_BUILDER_FIELD_ELEMENT_TAG]: FlyListItemAudienceBuilderFields;
  }
}
